import { UIActionTypes, ChangeUserOptionsActionType } from "./types";
import { ActionCreator } from "../types/store-types";

export const changeUserOptions: ActionCreator<ChangeUserOptionsActionType> = (
  payload
) => ({
  type: UIActionTypes.CHANGE_USER_OPTIONS,
  payload,
});
